<template>
  <div class="page">
    <div class="page__bd" style="height: 100%;">
      <div class="weui-tab">
        <div v-if="showCard" @click="() => {showCard = false;}">
          <invite-colleague-card/>
        </div>
        <div class="weui-tab__panel">
          <keep-alive>
            <router-view></router-view>
          </keep-alive>
        </div>
        <div class="weui-tabbar">
          <a
            href="javascript:;"
            class="weui-tabbar__item"
            :class="{'weui-bar__item_on': activeTab=='home'}"
            @click="setActive('home', '')"
          >
            <span class="weui-tabbar__icon iconfont icon-home" />
            <p class="weui-tabbar__label">首页</p>
          </a>
          <a
            href="javascript:;"
            class="weui-tabbar__item"
            :class="{'weui-bar__item_on': activeTab=='b2b'}"
            @click="setActive('b2b', '/b2b')"
          >
            <span class="weui-tabbar__icon iconfont icon-b2b" />
            <p class="weui-tabbar__label">B2B</p>
          </a>
          <a
            href="javascript:;"
            class="weui-tabbar__item"
            :class="{'weui-bar__item_on': activeTab=='process'}"
            @click="setActive('process', '/process')"
          >
            <span style="display: inline-block;position: relative;">
              <span class="weui-tabbar__icon iconfont icon-approval" />
              <span
                class="weui-badge"
                v-show="count.approval"
                style="position: absolute;top: -2px;right: -13px;"
              >{{count.approval}}</span>
            </span>
            <p class="weui-tabbar__label">我的审批</p>
          </a>
          <a
            href="javascript:;"
            class="weui-tabbar__item"
            :class="{'weui-bar__item_on': activeTab=='report'}"
            @click="setActive('report', '/report')"
          >
            <span class="weui-tabbar__icon iconfont icon-report" />
            <p class="weui-tabbar__label">报表</p>
          </a>
          <a
            href="javascript:;"
            class="weui-tabbar__item"
            :class="{'weui-bar__item_on': activeTab=='profile'}"
            @click="setActive('profile', '/profile')"
          >
            <span class="weui-tabbar__icon iconfont icon-user" />
            <p class="weui-tabbar__label">我</p>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import InviteColleagueCard from "@/components/InviteColleagueCard.vue";

export default {
  components: {
    InviteColleagueCard
  },
  data() {
    return {
      showCard: false,
      count: {
        approval: 0
      }
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 取统计信息
      vm.getCountData();
      if(from.name == "Register") {
        vm.showCard = true
      }
    });
  },
  computed: {
    activeTab() {
      const meta = this.$route.meta;
      return meta ? meta.activeTab : 'home';
    }
  },
  methods: {
    getCountData() {
      const me = this;
      me.$ajax({
        url: "/api/process/instance/my_approval_count"
      }).then(function(res) {
        if (res.success) {
          me.count.approval = res.data;
        }
      });
    },
    setActive(name, path) {
      const me = this;
      me.$router.push("/make" + path);
      me.getCountData();
    }
  }
};
</script>

<style scoped>
.weui-tabbar__icon {
  font-size: 24px;
  line-height: 27px;
}
</style>